import { useEditorLotusAvailable } from '@/hooks/editor/useEditorLotusAvailable'
import { useIsInternalAdmin } from '@/hooks/utility/useIsInternalAdmin'

/**
 * Whether the editor offers its staff-only Lotus controls here: the new text
 * boxes switch, the convert icon and the turnover control. Only internal
 * staff (`useIsInternalAdmin`) get them, and only where Lotus text boxes are
 * offered for the open order's funeral home (`useEditorLotusAvailable`).
 * Anywhere else the editor behaves as it does for a funeral home user.
 */
export const useEditorLotusOffered = (): boolean => {
  const isInternalAdmin = useIsInternalAdmin()
  const available = useEditorLotusAvailable()
  return isInternalAdmin && available
}
